import { useState, useEffect } from "react";

import throttle from "lodash.throttle";

import { useFooterContext } from "../../../components";

import { Bar, Progress } from "./ProgressBar.styles";

type ProgressBarProps = {
    progressLabel?: string;
};

const ProgressBar = ({ progressLabel }: ProgressBarProps) => {
    const [yPercent, setYPercent] = useState<number>(0);

    const { footerHeight } = useFooterContext();

    useEffect(() => {
        // define handler
        const scrollPercentHandler = throttle(() => {
            const scrollTop = window.scrollY;
            const docHeight = document.body.offsetHeight;
            const windowHeight = window.innerHeight;
            const height = docHeight - windowHeight - footerHeight;
            const scrollPercent = Math.round(
                Math.min(100 / (height / scrollTop), 100)
            );
            setYPercent(scrollPercent);
        }, 100);

        // set listener
        window.addEventListener("scroll", scrollPercentHandler);

        // remove listener
        return () => {
            window.removeEventListener("scroll", scrollPercentHandler);
        };
    }, [footerHeight]);

    return (
        <Bar>
            <Progress
                role="progressbar"
                aria-label={progressLabel}
                aria-valuenow={yPercent}
                aria-valuemin={0}
                aria-valuemax={100}
                style={{ width: `${yPercent}%` }}
                complete={yPercent === 100}
            />
        </Bar>
    );
};

export default ProgressBar;
